import { useState } from 'react';

type IProps<T> = {
  defaultValue?: T;
};

export function useChange<T = string>({ defaultValue }: IProps<T> = {}) {
  const [value, setValue] = useState<T | undefined>(defaultValue);

  return {
    value,
    setValue,
  };
}
